module.exports = __webpack_public_path__ + "img/ferrari-a1.65584f4e.jpg";